export default __webpack_public_path__ + "fonts/4bf4b0679a2c1166e489d57b6b3a435e.svg";